import { FC } from 'react'

import { US_SUBDIVISIONS } from '@/constants/regions/usSubdivisions'
import { Subdivision } from '@/types/region'

import { MultiSelectBox } from '../MultiSelectBox'

export const US_SUBDIVISIONS_LABEL = 'US State'
export const US_SUBDIVISIONS_TEST_ID = 'us-subdivisions-multiselect' as const

type Props = {
  value: Subdivision[]
  onChange: (value: Subdivision[]) => void
  label?: string
  testId?: string
  getOptionId?: (option: Subdivision) => string
}

export const UsSubdivisionsMultiselect: FC<Props> = ({ ...props }) => {
  return (
    <MultiSelectBox
      getOptionId={(option) => String(option.code)}
      label={US_SUBDIVISIONS_LABEL}
      testId={US_SUBDIVISIONS_TEST_ID}
      {...props}
      formatChipOption={(option) => option.name}
      defaultValue={undefined}
      options={US_SUBDIVISIONS.sort((a, b) => a.name.localeCompare(b.name))}
    />
  )
}
